import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import React, { FC, useContext, useState } from 'react';
import Context from '../context';
import { ActionTypes } from '../types/types';

import { AdvancedOptions } from './advancedoptions';
import { BrowseWorkflow } from './browseworkflow';
import { MonthlyRunsControl } from './monthlyrunscontrol';
import { Resources } from './resources';
import { isValidJsonString } from '../utils/calculatorutils';
import { Label } from 'office-ui-fabric-react/lib/Label';

export const CalculatorConfigContainer: FC<{}> = () => {
    const [monthlyRuns, setMonthlyRuns] = useState(1);
    const { state, dispatch } = useContext(Context);

    const getLargeActions = (): any => {
        const largeActionsUnformatted = state.allActionsWithLargePayload;
        let largeActionsFormatted: Record<string, any> = {};
        largeActionsUnformatted.forEach(largeAction => {
            largeActionsFormatted[largeAction] = { size: 32768 }
        });

        return largeActionsFormatted;
    }

    const handleMonthlyRunsChange = (monthlyRunsValue: number): void => {
        setMonthlyRuns(monthlyRunsValue);
    }

    const handleMonthlyRunsUpdate = (): void => {
        const action = {
            type: ActionTypes.UPDATE_MONTHLY_RUNS,
            payload: monthlyRuns
        };
        dispatch(action);
    }

    const handleCalculateResponseSuccessful = (): void => {
        const action = {
            type: ActionTypes.UPDATE_CALCULATE_CLICKED,
            payload: true
        };
        dispatch(action);
        handleMonthlyRunsUpdate();
        window.scroll({
            top: 1000,
            behavior: 'smooth'
        });
    }

    const handleOnClickCalculate = async(): Promise<void> => {
        const calculateAction = {
            type: ActionTypes.UPDATE_CALCULATE_BUTTON_TEXT,
            payload: Resources.CALCULATE_BUTTON_TEXT_CALCULATING
        };
        dispatch(calculateAction);

        const isValidJson = state.workflowDefinition && isValidJsonString(state.workflowDefinition);
        if (isValidJson) {
            const workflow = JSON.parse(state.workflowDefinition);
            const repetitions = state.repeatingActionsIterations;
            const largeActions = getLargeActions();
            const body = { repetitions, workflow, actionMetadata: {...largeActions} };
    
            const jsonResponse = await fetch(Resources.REQUEST_URI_COST_ANALYZER, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            }).then(response => response.json()).then(data => {
                return data;
            });

            const responseSuccessful = parseResponse(jsonResponse);
            if (responseSuccessful) {
                handleCalculateResponseSuccessful();
            }
        } else {
            const action = {
                type: ActionTypes.UPDATE_ERROR_MESSAGE,
                payload: Resources.INVALID_JSON_TEXT
            };
            dispatch(action);
        }
        const calculateActionCompleted = {
            type: ActionTypes.UPDATE_CALCULATE_BUTTON_TEXT,
            payload: Resources.CALCULATE_BUTTON_TEXT
        };
        dispatch(calculateActionCompleted);
    }

    const parseResponse = (response: any): boolean => {
        let errorMessage = '';
        if (response.error) {
            errorMessage = `${response.error.code}: ${response.error.message}`;
        } else {
            const responseObj = response;
            const operationData = {
                blobReadMin: responseObj.operationsSummary.blobReadOperations.minimum,
                blobReadMax: responseObj.operationsSummary.blobReadOperations.maximum,
                blobReadBestGuess: responseObj.operationsSummary.blobReadOperations.value,
                blobWriteMin: responseObj.operationsSummary.blobWriteOperations.minimum,
                blobWriteMax: responseObj.operationsSummary.blobWriteOperations.maximum,
                blobWriteBestGuess: responseObj.operationsSummary.blobWriteOperations.value,
                queueMin: responseObj.operationsSummary.queueOperations.minimum,
                queueMax: responseObj.operationsSummary.queueOperations.maximum,
                queueBestGuess: responseObj.operationsSummary.queueOperations.value,
                tableMin: responseObj.operationsSummary.tableOperations.minimum,
                tableMax: responseObj.operationsSummary.tableOperations.maximum,
                tableBestGuess: responseObj.operationsSummary.tableOperations.value
            }
            const action = {
                type: ActionTypes.UPDATE_OPERATION_COUNT_DATA,
                payload: operationData
            };
            dispatch(action);
        }
        const action = {
            type: ActionTypes.UPDATE_ERROR_MESSAGE,
            payload: errorMessage
        };
        dispatch(action);
        return !response.error;
    }

    return (
        <>
            <Label className="calc-config-workflow-settings-label">{Resources.WORKFLOW_SETTINGS_LABEL}</Label>
            <div className="calc-config">
                <div className="calc-config-standard">
                    <BrowseWorkflow />
                    <MonthlyRunsControl handleMonthlyRunsChange={handleMonthlyRunsChange} monthlyRuns={monthlyRuns} />
                </div>
                <AdvancedOptions />
            </div>
            <DefaultButton className="calc-calculate-button" aria-label="Calculate button" text={state.calculateButtonText} onClick={handleOnClickCalculate}/>
        </>
    );
}